import { SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Divider,
  Flex,
  Grid,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text
} from "@chakra-ui/react";
import moment from "moment";
import { ChangeEvent, useEffect, useState } from "react";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Loading from "../../../components/common/Loading";
import closeshot from "../../../img/closeshot.png";
import { IAdvertisedCourses } from "../../../models/advertisedcourse.model";
import coursesService from "../../../services/courses.service";

const AdvertisedCourses = () => {
  const [loading, setLoading] = useState(true);
  const [advertisedCourses, setAdvertisedCourses] = useState<
    IAdvertisedCourses[]
  >([]);
  const [filteredAdvertisedCourses, setFilteredAdvertisedCourses] = useState<
    IAdvertisedCourses[]
  >([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState<boolean>(false);

  useEffect(() => {
    coursesService.getAdvertisedCourses().then((res) => {
      setAdvertisedCourses(res);
      setFilteredAdvertisedCourses(res);
      setLoading(false);
    });
  }, []);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();

    if (!searchTerm) {
      setFilteredAdvertisedCourses(advertisedCourses);
    } else {
      if (advertisedCourses) {
        const filtered = advertisedCourses.filter((each: any) =>
          each.course.name.toLowerCase().includes(searchTerm)
        );
        setFilteredAdvertisedCourses(filtered);

        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box w="100%">
          <DashboardHeader />
          <Flex
            justifyContent="center"
            alignItems="center"
            w="100%"
            h="auto"
            bg="#F9F8F8"
            minHeight="40rem"
          >
            {/* Container */}
            <Stack
              w="70%"
              my="5rem"
              h="fit-content"
              bg="white"
              p="1.7rem"
              spacing="1.6rem"
            >
              <Flex justifyContent="space-between">
                <Text fontWeight="500" fontSize="18px" lineHeight="25px">
                  Advertised Courses
                </Text>
                {/* <Text color="red">see all</Text> */}
              </Flex>
              <Divider borderColor="#8B8B8B" />
              <HStack spacing="1.6rem">
                <InputGroup size="sm" w="20rem">
                  <Input
                    placeholder="search for advertised courses"
                    borderWidth="1px"
                    h="2.3rem"
                    fontSize="14px"
                    borderColor="#8B8B8B"
                    color="#8B8B8B"
                    onChange={(e) => handleSearchChange(e)}
                  />
                  <InputRightElement>
                    <SearchIcon color="#8B8B8B" mt="1.5px" />
                  </InputRightElement>
                </InputGroup>
                {/* <Menu>
                                        <MenuButton bg="white" borderWidth='1px' h="2.3rem" fontSize="14px" fontWeight="normal" width="8rem" borderColor="#8B8B8B" _hover={{ bg: 'gray.400' }}
                                            _expanded={{ bg: "#f2f4ff" }}
                                            borderRadius="none" as={Button} rightIcon={<ChevronDownIcon />}>
                                            Status
                                        </MenuButton>
                                        <MenuList>
                                            <MenuItem>Download</MenuItem>
                                            <MenuItem>Create a Copy</MenuItem>
                                            <MenuItem>Mark as Draft</MenuItem>
                                            <MenuItem>Delete</MenuItem>
                                            <MenuItem>Attend a Workshop</MenuItem>
                                        </MenuList>
                                    </Menu> */}
              </HStack>

              <Grid bg="white" templateColumns="repeat(4, 1fr)" gap={8}>
                {filteredAdvertisedCourses &&
                  filteredAdvertisedCourses.map((each) => (
                    <Box
                      key={each.id}
                      boxShadow="0px 3.50207px 7.87967px rgba(51, 49, 49, 0.09)"
                      bg="white"
                    >
                      {each.course.cover_image ? (
                        <Image
                          objectFit="cover"
                          height={"120px"}
                          width="100%"
                          src={each.course.cover_image}
                        />
                      ) : (
                        <Image
                          objectFit="cover"
                          height={"120px"}
                          width="100%"
                          src={closeshot}
                        />
                      )}
                      <Box width="90%" mx="auto" mt="21px" mb="27px">
                        <Text
                          mb="15px"
                          color="#616161"
                          fontSize="14px"
                          fontWeight="400"
                        >
                          {each.course.name}
                        </Text>
                        <Flex justifyContent="space-between">
                          <Text
                            px="15px"
                            fontSize="10px"
                            pt="3px"
                            bg=" #EC3337"
                            borderRadius="7px"
                            color="white"
                          >
                            {" "}
                            {moment(each.admission_start).fromNow()}
                          </Text>
                          <Text fontSize="16px" fontWeight="600">
                            N{each.course.cost}
                          </Text>
                        </Flex>
                      </Box>
                    </Box>
                  ))}
              </Grid>
            </Stack>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default AdvertisedCourses;
